export const agentTableColumns = [
  {
    key: "check",
    display_name: "",
    headerStyles: {
      background: "#1B1F2E",
      width: "4%",
      borderRadius: "6px 0 0 0",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
  },
  {
    key: "name",
    display_name: "Engine Name & type",
    headerStyles: {
      background: "#1B1F2E",
      "font-weight": "600",
      color: "#fff",
      width: "30%",
    },
    _config: {
      type: "title_with_description",
      subtitleKey: "typeLabel",
      subtitleIconMap: {
        Local:   "assets/images/virtusa-icons/local-agent.svg",
        Cluster: "assets/images/virtusa-icons/cluster-agent.svg",
      },
    },
  },
  {
    key: "statusLabel",
    display_name: "Status",
    headerStyles: {
      background: "#1B1F2E",
      "font-weight": "600",
      color: "#fff",
      width: "18%",
    },
    _config: {
      type: "lozenge_status",
      classMapping: {
        Online:    "agent-online-class    agent-status-card",
        ONLINE:    "agent-online-class    agent-status-card",
        Offline:   "agent-offline-class   agent-status-card",
        OFFLINE:   "agent-offline-class   agent-status-card",
        Executing: "agent-executing-class agent-status-card",
        EXECUTING: "agent-executing-class agent-status-card",
        Crashed:   "agent-crashed-class   agent-status-card",
        CRASHED:   "agent-crashed-class   agent-status-card",
      },
      suffixActionIcon: {
        conditionalKey: "status",
        condition: "CRASHED",
        iconSrc: "assets/images/table/logs.svg",
        actionType: "conditional-svg",
      },
    },
  },
  {
    key: "expiration",
    display_name: "Expire Date",
    headerStyles: {
      background: "#1B1F2E",
      "font-weight": "600",
      color: "#fff",
      width: "14%",
    },
    _config: {
      type: "date",
    },
  },
  {
    key: "setup",
    display_name: "Setup Engine",
    headerStyles: {
      background: "#1B1F2E",
      "font-weight": "600",
      color: "#fff",
      width: "16%",
    },
    _config: {
      type: "conditional-button",
      conditionalCheck: {
        key: "type",
        value: "LOCAL",
      },
      classNames: "agent-setup-btn",
      name: "Setup Engine",
      isClickable: "true",
    },
  },
  {
    key: "edit",
    display_name: "Action",
    headerStyles: {
      background: "#1B1F2E",
      "font-weight": "600",
      color: "#fff",
      borderRadius: "0 6px 0 0",
      width: "8%",
      "text-align": "center",
    },
    cellStyles: { "text-align": "center" },
    customClass: "agent-edit-col",
    _config: {
      type: "svg",
      value: "assets/images/virtusa-icons/edit-project.svg",
      isClickable: "true",
    },
  },
];
